import { Route } from "react-router-dom";
import { FileParserUploadV2 } from "../pages/fileParser/fileParserv2";
import { ExtractionsPage } from "../pages/extraction/extractions/ExtractionsPage";
import { ViewExtractionPage } from "../pages/extraction/viewExtraction/ViewExtractionPage";
import { ApiKeysPage } from "../pages/extraction/apiKeys/ApiKeysPage";
import { TemplatesV2Page } from "../pages/templates/v2/TemplatesPage";
import { IndividualTemplateV2Page } from "../pages/templates/v2/IndividualTemplate";
import { ReportExtractionsPage } from "../pages/reportExtraction/ReportExtractionsPage";
import { NewReportExtractionPage } from "../pages/reportExtraction/NewReportExtractionPage";
import { ViewReportExtractionPage } from "../pages/reportExtraction/ViewReportExtractionPage";
import { RequireReportExtractions } from "./RequireReportExtractions";

export const getExtractionRoutes = () => {
  return [
    <Route key="apiKeys" path="apiKeys" element={<ApiKeysPage />} />,
    <Route key="new" path="extraction/new" element={<FileParserUploadV2 />} />,
    <Route
      key="extractions"
      path="extraction/extractions"
      element={<ExtractionsPage />}
    />,
    <Route
      key="view"
      path="extraction/view/:extractionId"
      element={<ViewExtractionPage />}
    />,
    <Route key="templates" path="templates" element={<TemplatesV2Page />} />,
    <Route
      key="template"
      path="templates/v2/:templateId"
      element={<IndividualTemplateV2Page />}
    />,
    // Pathless guard route: the paths below are unchanged, and the flag is read
    // reactively inside the guard instead of at router-creation time.
    <Route
      key="report-extractions"
      element={
        <RequireReportExtractions redirectTo="/dashboard/extraction/new" />
      }
    >
      <Route
        path="report-extraction/jobs"
        element={<ReportExtractionsPage />}
      />
      <Route
        path="report-extraction/new"
        element={<NewReportExtractionPage />}
      />
      <Route
        path="report-extraction/view/:jobId"
        element={<ViewReportExtractionPage />}
      />
    </Route>,
  ];
};
